<template>
  <el-dialog
    title="推送用户"
    :visible.sync="dialogVisible"
    width="800px"
    center
    >
    <el-radio-group v-model="user_type" @input='getList()'>
      <el-radio-button label="community">社工</el-radio-button>
      <el-radio-button label="admin" v-if="!hasApp">后台管理员</el-radio-button>
      <el-radio-button label="volunteer">志愿者</el-radio-button>
      <el-radio-button label="ordinary">普通用户</el-radio-button>
    </el-radio-group>
    
    <div class="flex-fs" style="margin-top: 15px;">
      <el-input
         placeholder="请输入姓名搜索"
         prefix-icon="el-icon-search" style="width: 300px;margin-right: 15px;"
         v-model="key" clearable @clear="search">
      </el-input>
      <el-button type="primary" @click="search">搜索</el-button>
    </div>
    
    <div style="margin: 15px 0 0;"></div>
    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    <el-checkbox-group v-model="checkedList" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="city in list" :label="city.uid" :key="city.uid">{{city.user_name}}</el-checkbox>
    </el-checkbox-group>
    
    <div class="picked">
      <div v-if="!notice_scope.length">- 请选择推送用户 -</div>
      <!-- <span class="all" v-if="checkAll">
        <el-link type="primary" :underline="false">● 全部社工</el-link>
        <el-link type="primary" :underline="false">● 全部后台管理员</el-link>
        <el-link type="primary" :underline="false">● 全部志愿者</el-link>
        <el-link type="primary" :underline="false">● 全部普通用户</el-link>
      </span> -->
      <template v-else>
        <el-tag
        v-for="(tag,i) in notice_scope_set"
        :key="tag.id"
        @close='del(tag)'
        closable>
        {{ tag.user_name }}
        </el-tag>
      </template>
      
    </div>  
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">关 闭</el-button>
      <el-button @click="save">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    data() {
      return {
        dialogVisible: false,
        user_type: 'community',
        notice_scope: [],
        list: [],
        checkAll: false,
        checkedList: [],
        isIndeterminate: true,
        saveList: [],
        key: '',
        publish_type: []
      }
    },
    computed:{
      notice_scope_set(){
        let map = new Map();
        return this.notice_scope.filter(item => !map.has(item['user_id']) && map.set(item['user_id'],1))
      },
      hasApp(){
        return this.publish_type.find(i=>i=='push')
      }
    },
    methods: {
      show(list, publish_type){
        this.publish_type = publish_type
        this.notice_scope = list || []
        this.getList()
        this.dialogVisible = true
      },
      search(){
        this.list = this.saveList.filter(i=>i.user_name.indexOf(this.key) > -1)
      },
      del(item,i){
        this.notice_scope = this.notice_scope.filter(i=>i.user_id != item.user_id)
        this.checkedList = this.checkedList.filter(i=>i != item.user_id)
      },
      handleCheckAllChange(val) {
        console.log('handleCheckAllChange', val)
        if(val){ // 全选
          this.checkedList = this.list.map(i=>{ return i.uid });
          this.checkedList.forEach(uid=>{
            if(!this.notice_scope.find(k=>k.user_type == this.user_type && k.user_id == uid)){
              this.notice_scope.push({
                user_type: this.user_type,
                user_id: uid,
                user_name: this.list.find(k=>k.uid == uid).user_name
              })
            }
          })
          this.checkAll = true
          this.isIndeterminate = false
        }else{
          this.checkedList =  [];
          this.checkAll = false
          this.isIndeterminate = true
          this.notice_scope = this.notice_scope.filter(i=>i.user_type != this.user_type)
        }
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkedList.forEach(uid=>{
          if(!this.notice_scope.find(k=>k.user_type == this.user_type && k.user_id == uid)){
            this.notice_scope.push({
              user_type: this.user_type,
              user_id: uid,
              user_name: this.list.find(k=>k.uid == uid).user_name
            })
          }
        })
        this.notice_scope = this.notice_scope.filter(i=>(i.user_type == this.user_type && this.checkedList.find(j=>j == i.user_id) || i.user_type !== this.user_type))
        
        this.checkAll = this.notice_scope.filter(i=>(i.user_type == this.user_type)).length === this.list.length
        this.isIndeterminate = !this.checkAll
      },
      getList(){
        userInfoAPI.getSystemUserList({
          user_type: this.user_type
        }).then(({ data })=>{
          if (data.code == 0) {
            this.list = data.data
            this.saveList = JSON.parse(JSON.stringify(this.list))
            this.checkedList = this.notice_scope.filter(i=>(i.user_type == this.user_type)).map(j=>{ return j.user_id })
            this.checkAll = this.checkedList.length === this.list.length
            this.isIndeterminate = this.checkedList.length < this.list.length
          } else {
            this.$message({
              showClose: true,
              message: data.msg,
              type: 'error'
            })
          }
        })
      },
      save(){
        this.$emit('change',this.notice_scope)
        this.dialogVisible = false
      }
    }
  }
</script>

<style scoped lang="scss">
  h3,p{
    text-align: center;
  }
  p{
    margin: 40px 0;
  }
  .el-icon-date,.el-icon-user{
    margin-right: 10px;
    font-size: 25px;
  }
  .el-icon-user{
    margin-left: 50px;
  }
  .el-checkbox-group{
    display: flex;
    flex-wrap: wrap;
    max-height: 600px;
    overflow-x: auto;
  }
 .el-checkbox{
   width: 25%;
   padding: 10px 15px 10px 0;
   margin-right: 0;
   overflow: hidden;
   display: flex;
   flex-wrap: wrap;
   align-items: center;
 }
 /deep/.el-checkbox__label{
   flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: break-spaces;
  }
 .picked{
   border: 1px dashed #999;
   border-radius: 10px;
   padding: 0 0 20px 20px;
   min-height: 120px;
   margin-top: 30px;
   max-height: 600px;
   overflow-x: auto;
   div{
     line-height: 70px;
     padding: 20px 20px 0 0;
     text-align: center;
     color: #ccc;
   }
   .el-link{
     display: block;
     margin-top: 15px;
   }
   .el-tag{
     margin: 20px 20px 0 0;
   }
 }
 /* 设置滚动条的样式 */
 ::-webkit-scrollbar {
   width: 5px;
 }
 
 /* 滚动槽 */
 ::-webkit-scrollbar-track {
   background-color: #eee;
   border-radius: 10px;
 }
 
 /* 滚动条滑块 */
 ::-webkit-scrollbar-thumb {
   border-radius: 10px;
   background: #77baff;
   opacity: 0.7;
   -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0);
 }
 
 ::-webkit-scrollbar-thumb:window-inactive {
   background: #77baff;
   opacity: 0.7;
 }
 
</style>
